export const filterSorterColumnsProps = <T>(columns: Array<T>): Array<T> =>
	columns.map((column) => ({
		...column,
		sorter: false
	}))
